import ContensisRepository from '~/repositories/ContensisRepository';

class RepositoryBaseService {
  contensis: ContensisRepository;
  source: ContensisRepository;
  protected outputProgress: boolean;

  constructor(
    // contensis is the current repository this instance is attached to
    contensis: ContensisRepository,
    // source is always the source repository
    source: ContensisRepository
  ) {
    this.contensis = contensis;
    this.source = source;
    this.outputProgress = source.context.payload.outputProgress || false;
  }

  get isSourceRepo() {
    // Allow logging to mention are we looking at 'source' or 'target' data
    return (
      this.source.alias === this.contensis.alias &&
      this.source.projectId === this.contensis.projectId
    );
  }
}
export default RepositoryBaseService;
